import Image from 'next/image'
import { AnimatePresence, m } from 'framer-motion'
import { useLocale } from 'next-intl'
import { AmplitudeEvents, sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'
import { usePathname } from 'next/navigation'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'
import { Link } from '@repo/web-ui/components/link'

interface PreviewProductCardProps {
  image?: string | null
  title: string
  slug: string
}

export function PreviewProductCard({ title, image, slug }: PreviewProductCardProps) {
  const locale = useLocale()
  const pathname = usePathname()
  const url = addOrReplaceLocaleInUrl(`${AppRoutes.PRODUCT}${slug}/`, locale)

  return (
    <Link
      href={url}
      component="a"
      onClick={(e: React.MouseEvent) => {
        e.preventDefault()
        sendAmplitudeEvent(
          AmplitudeEvents.RECOMMENDATION_CLICKED,
          {
            card_clicked: 'product',
            card_url: url,
            url: window.location.href,
            path: pathname,
          },
          () => {
            // @todo revise this after enabling client side navigation after migrating all producs (/product/) to this app
            document.location.href = url
          },
        )
      }}
    >
      <div className="rounded-2 bg-cf-dreamy-cloud-400 group relative h-full overflow-hidden">
        <div className="text-14 from-cf-dreamy-cloud-1000/75 text-cf-white absolute inset-0 bg-gradient-to-b to-transparent p-2 font-bold opacity-0 group-hover:opacity-100">
          <span
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {/* <div className="text-12 font-normal">Creator Name</div> */}
        </div>
        <AnimatePresence>
          {image ? (
            <m.div
              key={image}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="h-full w-full"
            >
              <Image
                alt={title}
                width="200"
                height="120"
                className="rounded-2 bg-cf-dreamy-cloud-400 h-full w-full object-cover"
                src={image.replace('beta-', '')}
              />
            </m.div>
          ) : null}
        </AnimatePresence>
      </div>
    </Link>
  )
}
